import React, { PropsWithChildren } from 'react';

export const forEachChildDeep = (
  children: React.ReactNode | React.ReactNode[],
  deepForEachFn: (child: React.ReactNode, index?: number) => void
): void => {
  React.Children.forEach(children, (child, index: number) => {
    if (React.isValidElement<PropsWithChildren>(child)) {
      // Each inside the child that has children
      forEachChildDeep(child.props.children, deepForEachFn);
    }
    deepForEachFn(child, index);
  });
};
